import React from 'react'
import { is_empty } from "../utils";

export const ErrorMessage = ({ value }) => !is_empty(value) && (
  <div className="alert alert-danger">
    {value}
  </div>
)